import { useTranslation } from "react-i18next";
import { TooltipHover } from "components/designV2/tooltip/tooltip";
import { CustomIcon } from "components/icon/customIcon.component";
import { ColorV2 } from "config/colors";
import { RowActionButton, RowActionSlot } from "../tips.styled";
import type { TipRowManagementActionProps } from "./tips.rows.types";

export const TipRowManagementAction = (
  props: TipRowManagementActionProps,
): JSX.Element => {
  const { t } = useTranslation();

  return (
    <RowActionSlot $column={6}>
      {props.shouldShowManualPayoutRevert ? (
        <TooltipHover text={t("Tips.Reset")} arrow="down">
          <RowActionButton
            type="button"
            aria-label={t("Tips.Reset")}
            onClick={() => props.onRevertManualPayout([props.tip.companyTipId])}
          >
            <CustomIcon name="v2/reset" size="18px" color={ColorV2.Blue1} />
          </RowActionButton>
        </TooltipHover>
      ) : props.shouldShowDelete ? (
        <TooltipHover text={t("Tips.Delete")} arrow="down">
          <RowActionButton
            type="button"
            aria-label={t("Tips.Delete")}
            onClick={() => props.onDelete(props.tip.companyTipId)}
          >
            <CustomIcon
              name="v2/trash"
              size="22px"
              color={ColorV2.NegativeRed}
            />
          </RowActionButton>
        </TooltipHover>
      ) : null}
    </RowActionSlot>
  );
};
